import { useEffect, useState } from "react";
import { getSessionToken, getTokenInfo } from "@/api/auth";
import { updateUserData } from "@/api/users";
import { PasswordPanel } from "./Password/PasswordPanel";

/** Profile tab for users without the Agents app: name, locked email, and the password card. */
export function ProfilePanel() {
  const [me, setMe] = useState<{ id?: string; firstName: string; lastName: string; email: string }>({ firstName: "", lastName: "", email: "" });
  const [msg, setMsg] = useState<{ ok: boolean; text: string } | null>(null);

  useEffect(() => {
    getTokenInfo(getSessionToken()).then((r: any) => r && !r.error && setMe(r));
  }, []);

  const input =
    "w-full rounded-lg border border-black/[0.08] bg-white px-3 py-2 text-[13px] text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20";

  const save = async () => {
    if (!me.firstName.trim() || !me.lastName.trim()) return setMsg({ ok: false, text: "First and last name can't be empty." });
    const res: any = await updateUserData(me.id, { token: getSessionToken(), data: { firstName: me.firstName, lastName: me.lastName } });
    if (res?.error || res instanceof Error) return setMsg({ ok: false, text: res.error || "Your name was not saved." });
    // The session token carries the name, so refresh it the way the old page did.
    window.location.href = "/login";
  };

  return (
      <div className="space-y-6" data-testid="unified-profile">
        <div className="rounded-xl bg-white shadow-sm ring-1 ring-black/[0.04] p-6">
          <h3 className="text-sm font-semibold text-gray-900 mb-5">Account</h3>
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            <div>
              <label className="mb-1.5 block text-xs font-medium text-gray-600">First name</label>
              <input className={input} value={me.firstName} onChange={(e) => setMe({ ...me, firstName: e.target.value })} />
            </div>
            <div>
              <label className="mb-1.5 block text-xs font-medium text-gray-600">Last name</label>
              <input className={input} value={me.lastName} onChange={(e) => setMe({ ...me, lastName: e.target.value })} />
            </div>
            <div className="sm:col-span-2">
              <label className="mb-1.5 block text-xs font-medium text-gray-600">Email</label>
              <input readOnly value={me.email} className={`${input} cursor-not-allowed bg-gray-50 text-gray-500`} />
              <p className="mt-1 text-[11px] text-gray-400">This is your sign-in email and can't be changed here.</p>
            </div>
          </div>
          <div className="mt-5 flex items-center justify-between">
            <p className={`text-xs ${msg?.ok ? "text-green-600" : "text-red-600"}`}>{msg?.text}</p>
            <button type="button" onClick={save} className="rounded-lg bg-gray-900 px-4 py-2 text-[13px] font-medium text-white hover:bg-gray-800">
              Save name
            </button>
          </div>
        </div>
        <PasswordPanel />
      </div>
  );
}
